module.exports = __webpack_public_path__ + "img/mesa_hl33.0a3de05b.png";